<div class="settings-box-shadow">
  <h3 class="no-left-margin" style="margin-bottom: 0">
    FlyMSG AI
    <span class="font-weight-bold">Typing Style</span>
  </h3>
  <ng-container *ngIf="adminOverride">
    <em>This setting is controlled by your administrator.</em>
  </ng-container>
  <p style="margin-top: 1em">
    This setting will define the way we write for you online using the FlyMSG AI writer (i.e. LinkedIn posts,
    comments etc.). If you want FlyMSG to type out the response in ChatGPT style (letter by letter), then, select
    that option. If you want FlyMSG to just cut and paste the whole write up into the text area, then select that.
  </p>
  <vng-card variant="ghost" padding="none" [formGroup]="form">
    <div>
      <vng-radio-group
        formControlName="typingStyle"
        [disabled]="adminOverride"
        aria-label="Select a typing style"
        class="license-options"
      >
        <vng-radio-button value="letter" class="plan-radio-button" style="margin-right: 20px">
          ChatGPT (letter by letter)
        </vng-radio-button>
        <vng-radio-button value="all" class="plan-radio-button"> Cut and Paste </vng-radio-button>
      </vng-radio-group>
    </div>
    <div *ngIf="typingStyle === 'letter'">
      <!-- v19.7 vng-range-slider replaces the native range input + appCustomRangeSlider
           directive. adminOverride is honored via the FormControl's own disable()
           (see updateTypingSpeedDisabledState() in the .ts) — vng-range-slider
           implements setDisabledState(), so do NOT add a [disabled] binding here.
           thumbLabel bubble is gone, the persistent wpm readout below reproduces it. -->
      <vng-range-slider
        class="w-100"
        [min]="20"
        [max]="60"
        [step]="5"
        ariaLabel="Typing speed"
        formControlName="typingSpeed"
      ></vng-range-slider>

      <div class="range-info">{{ typingSpeed }}wpm</div>
    </div>
    <div style="display:flex; justify-content:flex-end; align-items:center; gap:8px" class="settings-card-actions">
      <button
        type="button"
        vng-button
        variant="secondary"
        [disabled]="typingSpeed == 45 || adminOverride"
        (click)="setDefault()"
        tabindex="-1"
      >
        Set Default
      </button>
      <button
        type="button"
        vng-button
        variant="primary"
        [disabled]="adminOverride || !isDirty || isSaving"
        (click)="save()"
        tabindex="-1"
      >
        Save
      </button>
    </div>
  </vng-card>
</div>
